<script lang="ts">
  import CutoffTime from "@retailer/svelte/Shared/DistributorInfo/CutoffTime.svelte";
  import OrderMinimums from "@retailer/svelte/Shared/DistributorInfo/OrderMinimums.svelte";
  import OrderRequirementsModal from "@retailer/svelte/Shared/DistributorInfo/OrderRequirementsModal.svelte";

  export let distributorName: string;
  export let cutoffTime: string = "";
  export let minPurchase: number | null;
  export let minQuantity: string | null;
  export let notes: string = "";
  export let isMobile: boolean;
  export let onModalOpen = () => {};

  let divider = "·";
  let showModal = false;

  const openModal = () => {
    showModal = true;
    onModalOpen();
  };

  const hasOrderRequirements = !!cutoffTime || !!minPurchase || !!minQuantity || !!notes;
</script>

{#if hasOrderRequirements}
  <p
    id="orderRequirements"
    class="fizz-flex-row fizz-radius-medium fizz-text-small fizz-flex-wrap fizz-text-subdued"
    class:fizz-max-content={!isMobile}
    style="--gap: 0px"
  >
    {#if !!cutoffTime}
      <CutoffTime {cutoffTime} />

      <span class="fizz-inline-4">
        {divider}
      </span>
    {:else}
      <span class="fizz-inline-4"> Cutoff not available </span>

      <span class="fizz-inline-4">
        {divider}
      </span>
    {/if}

    {#if !!minPurchase || !!minQuantity}
      <OrderMinimums {minPurchase} {minQuantity} />

      <span class="fizz-inline-4">
        {divider}
      </span>
    {:else}
      <span class="fizz-inline-4"> Min not available </span>

      <span class="fizz-inline-4">
        {divider}
      </span>
    {/if}

    <span class="fizz-inline-4">
      <a
        class="fizz-text-inherit"
        href={"#"}
        data-testid="order-reqs-button"
        on:click|preventDefault={openModal}
      >
        <u>More order reqs</u>
      </a>
    </span>
  </p>

  <OrderRequirementsModal
    bind:showModal
    {distributorName}
    {cutoffTime}
    {minPurchase}
    {minQuantity}
    {notes}
  />
{:else}
  <span class="fizz-inline-4 fizz-flex-row fizz-text-small fizz-flex-wrap fizz-max-content">
    Order requirements not available
  </span>
{/if}
